import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import docsThumb from "../../../assets/images/documentsPreview/docsthumb.png";
import xlxThumb from "../../../assets/images/documentsPreview/xlxthumb.png";
import videoThumb from "../../../assets/images/documentsPreview/videothumb.png";
import pdfThumb from "../../../assets/images/documentsPreview/pdfthumb.png";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import { MODULE_API } from "../../../apis";
import DEATH_API from "../../../apis/death.api";
import { Menu, Dropdown, Modal, Button } from "antd";
import { modules } from "../moduleConstants";
import axios from "axios";
import swal from "sweetalert";
import "../importantDocument.css";

export const ModuleDocuments = () => {
  const { moduleName } = useParams();
  const [moduleData, setModuleData] = useState([]);
  const [moduleModal, setModuleModal] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const cardsMainRef = useRef(null);

  const data = [
    {
      id: 254,
      fileUrl:
        "https://assets-planet.s3.eu-west-1.amazonaws.com/media/92bda4a2-ce56-45c9-8616-5c77ff5647d9.csv",
      fileName: "9a9ce321-05b9-4dd3-9143-d43fb6e68d41.csv",
    },
    {
      id: 253,
      fileUrl:
        "https://assets-planet.s3.eu-west-1.amazonaws.com/media/74396e3e-304a-4abb-a178-6a85747af356.mp4",
      fileName: "WhatsApp Video 2023-06-26 at 10.54.40 AM.mp4",
    },
    {
      id: 252,
      fileUrl:
        "https://assets-planet.s3.eu-west-1.amazonaws.com/media/d7ddf195-e155-4f2d-896a-a8a72f7b983b.docx",
      fileName: "Documentdownload (3).docx",
    },
    {
      id: 251,
      fileUrl:
        "https://assets-planet.s3.eu-west-1.amazonaws.com/media/78c859eb-8843-41cf-8e87-91ae4a0771e7.pdf",
      fileName: "takaful.pdf",
    },
    {
      id: 250,
      fileUrl:
        "https://assets-planet.s3.eu-west-1.amazonaws.com/media/a5548926-fa52-4c2d-90c1-dd711e51398b.xlsx",
      fileName: "9d58b1a6-d3a2-439b-996e-cd3fa562ff37.xlsx",
    },
    {
      id: 249,
      fileUrl:
        "https://assets-planet.s3.eu-west-1.amazonaws.com/media/54dbeffa-82dd-49ea-9e25-7243249c310a.png",
      fileName: "Auto.png",
    },
  ];
  const getFilePreview = (item) => {
    const fileType =
      item.fileName.split(".").pop().toLowerCase() ||
      extractFileNameFromUrl(item.fileUrl);
    switch (fileType) {
      case "png":
      case "jpg":
      case "jpeg":
        return (
          <img
            src={item.fileUrl}
            alt={item.fileName}
            width={70}
            height={70}
            className="thumbnailDocs"
          />
        );
      case "mp4":
      case "webm":
        return (
          <img
            src={videoThumb}
            alt={item.fileName}
            width={70}
            height={70}
            className="thumbnailDocs"
          />
        );
      case "pdf":
        return (
          <img
            src={pdfThumb}
            alt={item.fileName}
            width={70}
            height={70}
            className="thumbnailDocs"
          />
        );
      case "docx":
      case "doc":
        return (
          <img
            src={docsThumb}
            alt={item.fileName}
            width={70}
            height={70}
            className="thumbnailDocs"
          />
        );
      case "xlsx":
      case "xls":
        return (
          <img
            src={xlxThumb}
            alt={item.fileName}
            width={70}
            height={70}
            className="thumbnailDocs"
          />
        );
      case "csv":
        return (
          <img
            src={xlxThumb}
            alt={item.fileName}
            width={70}
            height={70}
            className="thumbnailDocs"
          />
        );
      default:
        return (
          <img
            src={docsThumb}
            alt={item.fileName}
            width={70}
            height={70}
            className="thumbnailDocs"
          />
        );
    }
  };
  const handleClick = (link) => {
    window.open(link, "blank");
  };
  const extractFileNameFromUrl = (url) => {
    const urlParts = url.split("/");
    return urlParts[urlParts.length - 1]; // Get the last part of the URL, which is the file name
  };
  const getModuleDocs = async (page) => {
    try {
      setLoading(true);
      const docsOTP =
        userData && userData.otp
          ? userData.otp
          : localStorage.getItem("otp") && localStorage.getItem("otp");
      const response = await MODULE_API.fetchUploadedModulesDocs(
        moduleName,
        page,
        docsOTP
      );
      if (response && response.status === 400 && response.message !== "This is an expired OTP") {
        swal("Error", response.message, "error");
      }
      if (response && response.status === 400 && response.message === "This is an expired OTP") {
        swal("Error", response.message, "error");
        showModal();
      }
      if (response && response.data && response.data.rows) {
        localStorage.setItem("otp", docsOTP);
        setIsModalOpen(false);
        let allDocsData = response.data.rows.map((item) => {
          return {
            id: item.id,
            fileUrl: item.fileUrl && item.fileUrl,
            cmId: item.cmId && item.cmId,
            fileName:
              item.fileName ||
              (item.fileUrl && extractFileNameFromUrl(item.fileUrl)),
          };
        });
        setTotalPages(
          Math.ceil(response.data.count && response.data.count / 40)
        );
        setCurrentPage(page);
        setModuleData((prevState) => [...prevState, ...allDocsData]);
        if(moduleName && moduleName.toLowerCase()==="assets"){
          await getModuleCollection(1);
        }
        // setModuleData(allDocsData);
      }
      setLoading(false);
    } catch (error) {
      console.log("error while getting docs list==>", error);
      setLoading(false);
    }
  };
  const getModuleCollection = async (page) => {
    try {
      setLoading(true);
      const docsOTP =
        userData && userData.otp
          ? userData.otp
          : localStorage.getItem("otp") && localStorage.getItem("otp");
      const response = await MODULE_API.fetchUploadedModulesDocs(
        "collection",
        page,
        docsOTP
      );
      console.log("Docs listings==>", response);
      if (response && response.status === 400 && response.message !== "This is an expired OTP") {
        swal("Error", response.message, "error");
      }
      if (response && response.status === 400 && response.message === "This is an expired OTP") {
        swal("Error", response.message, "error");
        showModal();
      }
      if (response && response.data && response.data.rows) {
        localStorage.setItem("otp", docsOTP);
        setIsModalOpen(false);
        let allDocsData = response.data.rows.map((item) => {
          return {
            id: item.id,
            fileUrl: item.fileUrl && item.fileUrl,
            cmId: item.cmId && item.cmId,
            fileName:
              item.fileName ||
              (item.fileUrl && extractFileNameFromUrl(item.fileUrl)),
          };
        });
        setTotalPages(
          Math.ceil(response.data.count && response.data.count / 40)
        );
        setCurrentPage(page);
        setModuleData((prevState) => [...prevState, ...allDocsData]);
        // setModuleData(allDocsData);
      }
      setLoading(false);
    } catch (error) {
      console.log("error while getting docs list==>", error);
      setLoading(false);
    }
  };

  const handleInputChange = (name, value) => {
    setUserData({
      ...userData,
      [name]: value,
    });
  };
  const handleKeyPress = (event) => {
    console.log("submit");
    if (event.key === "Enter") {
      handleValidateOTP();
    }
  };
  const handleValidateOTP = async (event) => {
    console.log("submit");
    await getModuleDocs(currentPage);
  };
  const showModal = async () => {
    setIsModalOpen(true);
    try {
      let data = await DEATH_API.configOtp();
      if (data && data.message) {
        swal("Success", data.message, "success");
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const resenOTP = async () => {
    try {
      let data = await DEATH_API.configOtp();
      if (data && data.message) {
        swal("Success", data.message, "success");
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleCancel = () => {
    if (!localStorage.getItem("otp")) {
      localStorage.setItem("otp", "");
    }
    setIsModalOpen(false);
  };
  useEffect(() => {
    if (!localStorage.getItem("otp")) {
      localStorage.setItem("otp", "");
      showModal();
    } else {
      if (moduleName) {
        getModuleDocs(1);
      }
    }
  }, []);

  // useEffect(() => {
  //   if (moduleName) {
  //     getModuleDocs();
  //   }
  // }, []);

  const handleImageUpload = async (event) => {
    const fileSize = event.target.files[0].size / (1024 * 1000); // in MB
    console.log("fileSize in mb", fileSize);
    let uploadFile = event.target.files[0];
    if (uploadFile) {
      const formData = new FormData();
      formData.append("file", uploadFile);
      const name = uploadFile.name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      setLoading(true);
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: uploadFile.type,
      });
      const resupload = await axios.put(resdata.uploadUrl, uploadFile, {
        headers: { "Content-type": uploadFile.type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      console.log("image", res);
      setLoading(false);
      let objToSubmit = {
        fileName: name,
        fileUrl: res,
        type: moduleName,
      };
      handleSubmit(objToSubmit);
    }
  };
  const handleSubmit = async (body) => {
    console.log("Submit...", body);
    try {
      setLoading(true);
      const response = await MODULE_API.uploadModulesDocs(body);
      console.log("resposnse Upload", response);
      if (response && response.message) {
        swal("Success!", response.message, "success");
      }
      setModuleData([]);
      await getModuleDocs(1);
      setLoading(false);
    } catch (error) {
      console.log("error in update", error);
      setLoading(false);
    }
  };
  const handleOpenModuleModal = (docs) => {
    setModuleModal(true);
    setSelectedDocs(docs);
  };
  const handleCancelModuleModal = () => {
    setModuleModal(false);
    setSelectedDocs(null);
  };
  const hanldeModuleSelect = (selectedType) => {
    setModuleModal(false);
    if (selectedDocs && selectedDocs.cmId !== null) {
      swal(
        "Error",
        "You can not Move this Document this is already linked to module.",
        "error"
      );
      return;
    }
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to move this ?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, move it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let payload = {
            type: selectedType,
          };
          let res = await MODULE_API.moveModulesDocs(
            selectedDocs && selectedDocs.id,
            payload
          );
          if (res && res.status === 200) {
            swal("Success!", "Your Document has been Moved.", "success");
            setModuleData([]);
            await getModuleDocs(1);
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.log("error while updating User Defined", error);
        }
      } else {
        swal("Cancelled", "Your Document is safe :)", "error");
      }
    });
    setSelectedDocs(null);
  };

  const handleScroll = () => {
    const element = cardsMainRef && cardsMainRef.current;
    if (!element) return;

    const { scrollTop, scrollHeight, clientHeight } = element;

    if (scrollTop + clientHeight >= scrollHeight && currentPage < totalPages) {
      getModuleDocs(currentPage + 1);
    }
  };

  useEffect(() => {
    const element = cardsMainRef && cardsMainRef.current;
    if (!element) return;

    element.addEventListener("scroll", handleScroll);
    return () => {
      element.removeEventListener("scroll", handleScroll);
    };
  }, [currentPage, totalPages]);

  return (
    <div className="reportsMain" style={{ position: "relative" }}>
      <div className="reportcreate" style={{ justifyContent: "space-between" }}>
        <h3 className="selectHeadingMainDocs">
          Important Documents{" "}
          <span style={{ textTransform: "capitalize" }}>{moduleName} </span>
        </h3>
        <input
          type="file"
          id="image"
          name="image"
          onChange={handleImageUpload}
          style={{ display: "none" }}
        />
        <label
          className="addbuttonreport"
          htmlFor="image"
          style={{
            cursor: "pointer",
            pointerEvents:
              (!localStorage.getItem("otp") ||
                localStorage.getItem("otp") === "") &&
              "none",
            opacity:
              (!localStorage.getItem("otp") ||
                localStorage.getItem("otp") === "") &&
              "0.5",
          }}
        >
          Upload New
        </label>
      </div>
      <div className="documentGrid" ref={cardsMainRef}>
        {moduleData && moduleData.length > 0 ? (
          moduleData.map((item, index) => (
            <div
              title={item.fileName}
              key={index}
              className="documentCard"
              // onClick={() => {
              //   if (item.fileUrl) {
              //     handleClick(item.fileUrl);
              //   }
              // }}
            >
              {getFilePreview(item)}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  gap: "4px",
                  marginTop: "1rem",
                }}
              >
                <p
                  className="fileNameDocs"
                  style={{ margin: "0px" }}
                  title={item.fileName}
                >
                  {item.fileName.length > 20
                    ? `${item.fileName.substring(0, 17)}...`
                    : item.fileName}
                </p>
                <Dropdown
                  trigger={["click"]}
                  overlay={
                    <Menu>
                      <Menu.Item>
                        <div
                          onClick={() => {
                            handleOpenModuleModal(item);
                          }}
                        >
                          Move
                        </div>
                      </Menu.Item>
                      <Menu.Item>
                        <div
                          onClick={() => {
                            if (item.fileUrl) {
                              handleClick(item.fileUrl);
                            }
                          }}
                        >
                          View
                        </div>
                      </Menu.Item>
                    </Menu>
                  }
                >
                  <a
                    className="ant-dropdown-link"
                    style={{ padding: "0px 8px" }}
                    onClick={(e) => e.preventDefault()}
                  >
                    <img
                      className="imgIcon"
                      src={menuIcon}
                      height={15}
                      width={4}
                      alt="icon"
                    ></img>
                  </a>
                </Dropdown>
              </div>
            </div>
          ))
        ) : (
          <div style={{ width: "100%", textAlign: "center" }}>
            <h2 style={{ marginTop: "6rem" }}>
              No Document to Display for this Module.
            </h2>
          </div>
        )}
      </div>
      <Modal
        visible={moduleModal}
        footer={null}
        onCancel={handleCancelModuleModal}
        closable={false}
        centered
      >
        <h3 className="modaltitle">Select Module Type For Moving Document</h3>
        <h3 className="modaltitle" style={{ fontSize: "12px" }}>
          Which Module would you like to move with?
        </h3>
        <h3 className="selectHeading">Select Module</h3>
        <div
          style={{
            maxHeight: "25rem",
            overflowY: "auto",
            background: "#F4F7FE",
          }}
        >
          <div className="selectmain" style={{ paddingInline: "8px" }}>
            {modules &&
              modules.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {
                    hanldeModuleSelect(item.name);
                  }}
                  className="selectMaincards"
                  style={{
                    width: "48%",
                    cursor: moduleName === item.name && "not-allowed",
                    pointerEvents: moduleName === item.name && "none",
                    opacity: moduleName === item.name && "0.5",
                  }}
                >
                  <div className="selectMaincardsInner">
                    {" "}
                    <div
                      className="selectMainImages"
                      style={{ padding: "10px" }}
                    >
                      <img src={item.image} height={"25px"} alt={item.title} />{" "}
                    </div>
                    <div className="selectMainHeader">
                      <span
                        className="selectheadingValue"
                        style={{ fontSize: "12px" }}
                      >
                        {item.title}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          <button
            className="savebutton"
            onClick={() => {
              handleCancelModuleModal();
            }}
          >
            Cancel
          </button>
        </div>
      </Modal>
      <Modal visible={isModalOpen} footer={null} closable={false} centered>
        <h3
          className="modaltitle"
          style={{ color: "#4d5e80", marginBottom: "10px" }}
        >
          {" "}
          Important Documents
        </h3>
        <div className="">
          <h2
            className="otp-heading"
            style={{ color: "#4d5e80", marginBottom: "10px" }}
          >
            This passcode provides another layer of security for your important
            documents. The passcode is only valid for this session.
          </h2>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Enter OTP</h3>
            <input
              className="roleInput"
              placeholder="***OTP***"
              name="otp"
              onKeyPress={handleKeyPress}
              // value={formData && formData.subCategoryName}
              id="otp"
              onChange={(e) => {
                e.preventDefault();
                handleInputChange(e.target.name, e.target.value);
              }}
            />
          </div>
         <Button 
         onClick={()=>{
          resenOTP();
        }}>
        Resend OTP
        </Button>
          <div className="buttonsMain">
            <button
              className="cancelbutton"
              onClick={() => {
                handleCancel();
              }}
            >
              Cancel
            </button>
            <button
              className="savebutton"
              // disabled={!formData || !formData.subCategoryName}
              onClick={() => {
                handleValidateOTP();
              }}
            >
              Save
            </button>
          </div>
        </div>
        <NewLoader isLoading={loading} />
      </Modal>
      <NewLoader isLoading={loading} />
    </div>
  );
};
